export default __webpack_public_path__ + "static/media/gpay.6f3720ef.svg";